import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Shield, Copyright } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-card border-t py-1.5 px-6 w-full">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="flex items-center gap-6 h-10">
          <Link
            to="/eula"
            className="flex items-center gap-2 text-xs text-muted-foreground hover:text-foreground transition-colors h-full"
          >
            <FileText className="h-3 w-3" />
            <span>EULA</span>
          </Link>
          <Link
            to="/data"
            className="flex items-center gap-2 text-xs text-muted-foreground hover:text-foreground transition-colors h-full"
          >
            <Shield className="h-3 w-3" />
            <span>DATA POLICY</span>
          </Link>
        </div>
        <div className="flex items-center gap-2 text-xs text-muted-foreground h-10">
          <Copyright className="h-3 w-3" />
          <span>Copyright 2026 mapleos</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;